import { render, staticRenderFns } from "./santakInput.vue?vue&type=template&id=536bbf28&scoped=true&"
import script from "./santakInput.vue?vue&type=script&lang=js&"
export * from "./santakInput.vue?vue&type=script&lang=js&"
import style0 from "./santakInput.vue?vue&type=style&index=0&id=536bbf28&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bbf28",
  null
  
)

export default component.exports